import { actionFactory } from '@zedux/core';
export const pluginActions = {
    ecosystemWiped: actionFactory('ecosystemWiped'),
    edgeCreated: actionFactory('edgeCreated'),
    edgeRemoved: actionFactory('edgeRemoved'),
    evaluationFinished: actionFactory('evaluationFinished'),
    instanceReused: actionFactory('instanceReused'),
    // either cache or instance will always be defined, depending on the node type
    stateChanged: actionFactory('stateChanged'),
    statusChanged: actionFactory('statusChanged'),
};
